import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../../constants';
import {
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models';
import { UtilService } from '../../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithFingerPrintService {
  loginAuthHeaderForFingerprint: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.submitDeviceInformation+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: UtilService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithFingerPrint = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const uniqueIdentifier = this.utils.generateUniqueIdentifier();
    const encryptedTokenStored = this.utils.getLocalStorageValue('encyToken');
    const uniqueIdentifierStored = this.utils.getLocalStorageValue('uid');

    let payload: PostWithCredentials = {};

    if (encryptedTokenStored && uniqueIdentifierStored) {
      payload = {
        fingerprint: uniqueIdentifierStored,
        encryptedToken: encryptedTokenStored
      };
    } else {
      payload = {
        fingerprint: uniqueIdentifier
      };
    }

    const getLoginPostWithFingerPrintUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginPostWithFingerPrintUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginPostWithFingerPrintUrl
      }
    ];

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginPostWithFingerPrintUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthHeaderForFingerprint)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_FINGER_PRINT_SERVICE')
      .withCredentials(true)
      .create();
  };
}
